var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionPagemodeReverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0607 8.93934C23.6464 9.52513 23.6464 10.4749 23.0607 11.0607L10.1213 24L23.0607 36.9393C23.6464 37.5251 23.6464 38.4749 23.0607 39.0607C22.4749 39.6464 21.5251 39.6464 20.9393 39.0607L6.93934 25.0607C6.35355 24.4749 6.35355 23.5251 6.93934 22.9393L20.9393 8.93934C21.5251 8.35355 22.4749 8.35355 23.0607 8.93934ZM39.0607 8.93934C39.6464 9.52513 39.6464 10.4749 39.0607 11.0607L26.1213 24L39.0607 36.9393C39.6464 37.5251 39.6464 38.4749 39.0607 39.0607C38.4749 39.6464 37.5251 39.6464 36.9393 39.0607L22.9393 25.0607C22.3536 24.4749 22.3536 23.5251 22.9393 22.9393L36.9393 8.93934C37.5251 8.35355 38.4749 8.35355 39.0607 8.93934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionPagemodeReverse);
export default __webpack_public_path__ + "static/media/direction_pagemode_reverse.74a200290d21db51bd960707a3a6fb7c.svg";
export { ForwardRef as ReactComponent };